
<script>
/* eslint-disable */
export default {
    name: 'sessionclear',
    created() {
    this.clearLocalStorage();
  },
  methods: {
    clearLocalStorage() {
    localStorage.removeItem('previousPageData');
    localStorage.removeItem('sessionstarttime');
    }
  }
}
</script>

